import { LogLevel } from 'angular-auth-oidc-client';
import { Environment } from '../app/core/configuration';
import { internationalization } from './common/internationalization';

export const environment: Environment = {
  buildId: '#{{BUILD_ID}}#',
  internationalization: internationalization,
  ams: {
    baseUrl: 'https://ams.vueling.com',
    profileId: '9A870462-42E4-4933-9492-C66B23BA2089'
  },
  bugsnag: {
    active: 'true'
  },
  baseUrl: undefined,
  paymentTypes: {
    AC: 'American Express',
    DS: 'Discover',
    DN: 'Dinners Club',
    VR: 'Visa',
    IA: 'iDeal',
    CF: 'booking_details_component.flight_journey_summary_component.credit_file',
    SD: 'SEPA Direct Debit ',
    UA: 'UATP AirPlus',
    DM: 'Mastercard',
    SO: 'Sofort'
  },
  smartBaseUrl: 'https://tickets.vueling.com',
  groupsBaseUrl: 'https://groups.vueling.com/web/',
  micewebBaseUrl: 'https://partners.vueling.com/web/',
  skysalesWebBaseUrl: 'https://tickets.vueling.com/LoginAgency.aspx',
  umbraco: {
    baseUrl: 'https://beta.vueling.com'
  },
  btbBFF: {
    pbm: { baseUrl: 'https://b2t-api.vueling.com', nameApi: 'pbm' },
    bam: { baseUrl: 'https://b2t-api.vueling.com', nameApi: 'bam' },
    bav: { baseUrl: 'https://b2t-api.vueling.com', nameApi: 'bav' },
    bre: { baseUrl: 'https://b2t-api.vueling.com', nameApi: 'bre' }
  },
  smartWeb: 'https://tickets.vueling.com',
  analytics: {
    key: 'GTM-56RKXM6',
    activeDigitalData: true,
    activeEvents: false,
    enableTracing: false
  },
  sso: {
    enabledSSO: true,
    authority: 'https://b2t-api.vueling.com/idp',
    client_id: 'cd889b2f-4cf9-4f7d-b562-b2eb542d9a8e',
    response_type: 'code',
    redirect_uri: 'https://professionals.vueling.com/login',
    post_logout_redirect_uri: 'https://professionals.vueling.com',
    scope: 'openid profile b2b',
    silent_redirect_url: 'https://professionals.vueling.com/silent-callback.html',
    silentRenew: true,
    useRefreshToken: true,
    logLevel: LogLevel.Debug
  },
  configurations: {
    mmbConfig: {
      url: 'https://vy-managemybooking-spa-beta.vueling.app/'
    },
    monetateConfig: {
      active: false,
      enabledPages: ['bookinglist'],
      urlSync: '//se.monetate.net/js/2/a-02a953bb/d/vueling.com/entry.js',
      urlAsync: '//se.monetate.net/js/2/a-02a953bb/d/vueling.com/custom.js',
      async: false
    },
    newInvoiceConfig: {
      url: 'https://support-public.vueling.com/Vueling.NewInvoice.GAC.WebUI/'
    },
    UkTravelConfig: {
      url: 'https://www.gov.uk/guidance/check-when-you-can-get-an-electronic-travel-authorisation-eta'
    }
  },
  featureFlag: {
    redirectMMB: false,
    opportunityDemoEnabled: false,
    authorizedAccounts: '#{{AUTHORIZED_ACCOUNTS}}#'.split(',')
  },
  cookiePolicyConfig: {
    autoBlockUri: 'https://cdn.cookielaw.org/consent/eb440cb9-982b-4dfe-9764-a5f339ad9985/OtAutoBlock.js',
    sdkUri: 'https://cdn.cookielaw.org/consent/eb440cb9-982b-4dfe-9764-a5f339ad9985/otSDKStub.js',
    hashIntegritySdk: 'sha256-pQaN7Q+j7p2YP3cO9h1m53V1bS/6Zlpg02pOPRd0j/o=',
    dataDomainScript: 'eb440cb9-982b-4dfe-9764-a5f339ad9985',
    active: true
  }
};
